/**
 * CATÁLOGO DE POLÍTICA DE FESTIVO — PLAN-UX-01-B, ampliado en FASE 6.2 §S.
 *
 * El catálogo de FRECUENCIA (antes en este fichero) se sustituyó por
 * `componentes/recurrencia.ts`, que sí sabe construir BYDAY/BYSETPOS —
 * ver su cabecera para por qué el bloqueo original de FASE 3.2B ya no
 * aplica: el motor real (`generador/recurrencia.ts`) los soporta desde
 * FASE 6.2.
 */

/**
 * Los valores reales que guarda el modelo (`plan_lineas.politica_festivo`,
 * 0000/0049) son SALTAR/EJECUTAR/DESPLAZAR/DESPLAZAR_ANTERIOR — nunca
 * "omitir": el backend nunca renombra los tres históricos, sólo añade el
 * cuarto. Las etiquetas de aquí son sólo para mostrar, coherentes con el
 * vocabulario amigable del Excel
 * (`backend/src/importador/contrato.ts::POLITICA_FESTIVO_ES`).
 */
export const POLITICAS_FESTIVO: readonly { readonly valor: string; readonly etiqueta: string }[] = [
  { valor: 'EJECUTAR', etiqueta: 'Ejecutar igualmente' },
  { valor: 'SALTAR', etiqueta: 'Omitir (no se crea ocurrencia)' },
  { valor: 'DESPLAZAR', etiqueta: 'Siguiente día laborable' },
  { valor: 'DESPLAZAR_ANTERIOR', etiqueta: 'Anterior día laborable' },
];
